import React from 'react'
import { Button, Popconfirm } from 'antd'
import { DeleteOutlined } from '@ant-design/icons'
import { useTranslation } from 'next-i18next'
import { useAppDispatch } from 'src/app/hooks'
import { editCompanyDetails } from 'src/features'

const DeleteButton = ({ value, company }) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()

  const handleDelete = () => {
    const payload = { }
    payload[value] = null
    dispatch(editCompanyDetails(company.id, payload))
  }

  return (
    <Popconfirm
      title={t('general.SureDelete')}
      onConfirm={handleDelete}
      okText={t('general.Yes')}
      cancelText={t('general.Cancel')}
    >
      <Button
        danger
        type='text'
        className='radius-100'
        icon={<DeleteOutlined />}
      />
    </Popconfirm>
  )
}

export default DeleteButton
